import PropTypes from 'prop-types';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import { NS } from '@/constants';

import styles from './CartLogo.module.scss';
import { URLS } from '@/constants/urls';

const CartLogo = ({ total, whiteIcon = true }) => {
  const { t } = useTranslation(NS.CHECKOUT);

  return (
    <div className={styles['cart-logo']}>
      <Image
        data-rbf="mini-cart"
        className={styles['cart-logo-img']}
        src={whiteIcon ? URLS.CART_WHITE : URLS.CART_BLACK}
        alt={t('cart.articles')}
        height={24}
        width={24}
        loading="eager"
      />
      {!!total && (
        <span className={styles['cart-logo-total']} data-test-id="cart-logo-total" data-rbf="cart-logo-total">{total}</span>
      )}
    </div>
  );
};

CartLogo.propTypes = {
  total: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  whiteIcon: PropTypes.bool
};

export default CartLogo;
